module.exports = __webpack_public_path__ + "img/social_connection.27021348.png";